import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import db from "./firestore.js";

class Hiring extends React.Component{
    constructor(props){
       super(props);
       this.state = {
            All_data : [],
       }
    }

    componentDidMount(){
        console.log("+++++++++++++++++++");
        this.Get_data_from_firestore();
     }

    Get_data_from_firestore = () => {
        var response = [];
         const query = db.firestore().collection("Placements").get().then(querySnapshot => {
               console.log(`Received query snapshot of size ${querySnapshot.size}`);
               querySnapshot.docs.forEach((doc,index) => {
                    var document_id = doc.id;
                    var li_id = doc.data().status;
                    response.push({...doc.data(),"doc_id":document_id});
               });
                this.setState({
                    ...this.state,
                    All_data : response,
                });
        });
    }

    Table_rows = () => {
        var data = this.state.All_data;
        var res = [];
        if(data.length > 0){
            data.forEach((ele,index) => {
            var b = (
                            <tr id={ele.doc_id}>
                            <td class="pl-4" id="Table_Entries">{ele.Name}</td>
                            <td id="Table_Entries">{ele.Package}</td>
                            <td id="Table_Entries">{ele.Company}</td>
                            <td id="Table_Entries">{ele.Post}</td>
                            </tr>
                     );
                     res.push(b);
            });
            return res;
        }else{
            return (
                <div class="spinner-border text-dark" id="Spinner"></div>
            );
        }
    }



    render(){
        return (
            <div>
                <table class="table" id="kkkl">
  <thead>
    <tr>
      <th scope="col" class="pl-4">Candidate</th>
      <th scope="col">Package</th>
      <th scope="col">Company</th>
      <th scope="col">Post</th>
    </tr>
  </thead>
  <tbody>
        {this.Table_rows()}
  </tbody>
</table>
            </div>
        )
    }

}

export default Hiring;